import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./project.state";
import { getStorage } from "../../utilities/setting";
import { formatLocalizedDate } from "common/utils/utils";
import dayjs from "dayjs";

export const projectSlice = createSlice({
  name: "project",
  initialState: getStorage("projectState") || initialState,
  reducers: {
    updateProject: (state, action) => {
      const today = dayjs();
      const projectEndDate = dayjs(action.payload.end_date);

      const startDate = formatLocalizedDate(
        action.payload.start_date,
        "YYYY-MM-DD[T]00:00:00.000Z"
      );
      let endDate = formatLocalizedDate(
        action.payload.end_date,
        "YYYY-MM-DD[T]23:59:59.000Z"
      );

      if (
        projectEndDate &&
        (projectEndDate.isAfter(today) || projectEndDate.isSame(today, "day"))
      ) {
        endDate = formatLocalizedDate(
          today.subtract(1, "day"),
          "YYYY-MM-DD[T]23:59:59.000Z"
        );
      }

      state.project = {
        ...state.project,
        ...action.payload,
        start_date: startDate,
        end_date: endDate,
      };
    },
  },
});

export default projectSlice.reducer;
